// TODO: deprecate
import React, { useEffect } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import {
  array,
  string,
  func,
  bool,
  shape,
  element,
  oneOfType,
  arrayOf,
  node
} from 'prop-types'
import { isEmpty } from 'lodash'
import yn from 'yn'

import LoginFromStep from '../LoginFromStep/LoginFromStep'
import BrandLoader from '../BrandLoader/BrandLoader'

import { appRoutes } from '../../configuration/constants'
import { selectPathToContinueTo } from '../../redux/modal/selectors'
import { selectLoginSuccess } from '../../redux/user/selectors'
import { selectActiveModifyBooking } from '../../redux/modifyBooking/selectors'
import { clearPathname, continueToPathname } from '../../redux/modal/actions'
import filterGroupRoutes from '../../utilities/content/filterGroupRoutes'
import { selectConfigurationData } from '../../redux/configuration/selectors'
import { setIsCommercial } from '../../redux/ferryRouteSelections/actions'

const FerryRoutesFormsContainer = ({
  clientId,
  availabilityErrors,
  customerAccount,
  travelAgentAccount,
  crossingsLoading,
  labels,
  openModal,
  renderFormToggles,
  routeFormElement,
  routeMap,
  handleRouteChange,
  activeRouteGrouping
}) => {
  const dispatch = useDispatch()
  const pathToContinueTo = useSelector(selectPathToContinueTo)
  const loginSuccess = useSelector(selectLoginSuccess)
  const activeModifyBooking = useSelector(selectActiveModifyBooking)
  const configuration = useSelector(selectConfigurationData)
  // const [selected, setSelected] = useState('leisure')
  const groupRoutes = filterGroupRoutes(
    configuration.ferry.options.routes,
    activeRouteGrouping
  )

  const hasCommericalVehicle =
    groupRoutes[0]?.vehicleTypes?.some(
      vehicle => vehicle.resourceCode === 'TT'
    ) ?? false

  useEffect(() => {
    if (yn(process.env.REACT_APP_COMPONENT_ENABLE_ROUTE_GROUPINGS)) {
      const element = document.getElementById('ferry-route-forms')

      if (document.getElementById('ferry-route-forms')) {
        element.scrollIntoView()
      }
    }
  })

  useEffect(() => {
    if (pathToContinueTo && loginSuccess) {
      handleRouteChange(pathToContinueTo)
    }
  }, [pathToContinueTo, loginSuccess, handleRouteChange])

  // Effect runs on component unmount - clear login continue pathname
  //   in case the user was not logged in successfully after clicking link here
  // TODO: Come up with more stable approach for the "redirect after action" paradigm
  useEffect(() => {
    dispatch(setIsCommercial(false))
    return () => {
      dispatch(clearPathname())
    }
  }, []) // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    if (
      hasCommericalVehicle &&
      travelAgentAccount &&
      travelAgentAccount?.agentAccount?.groupCode === 'CT'
    ) {
      dispatch(setIsCommercial(true))
    }
  }, [travelAgentAccount, dispatch, hasCommericalVehicle])

  return (
    <div id="ferry-route-forms" className="ferry-routes__forms">
      <div
        className="ferry-routes__map u-bg-image"
        style={{ backgroundImage: 'url(' + routeMap + ')' }}
      >
        <img
          className="u-remove-element"
          src={routeMap}
          alt={labels.routeMap}
        />
      </div>
      <div className="ferry-routes__form">
        <div className="ferry-routes__form-container">
          <div className="ferry-routes__form-content">
            {!customerAccount && !travelAgentAccount && (
              <div>
                <LoginFromStep
                  openModal={openModal}
                  labels={labels}
                  loginLabel={`${labels.loginAccountMsg2}.`}
                  onLoginClick={() => {
                    dispatch(continueToPathname(appRoutes.account.pathname))
                  }}
                />
                <div className="ferry-routes__form-divider">
                  <div className="ferry-routes__form-divider-line" />
                  <div className="ferry-routes__form-divider-text">
                    {labels.or}
                  </div>
                  <div className="ferry-routes__form-divider-line" />
                </div>
              </div>
            )}

            <h2 className="theme-title-variant-two">
              {activeModifyBooking
                ? labels.bookingSelectionHeaderModify
                : labels.bookingSelectionHeader}
            </h2>

            {/* {hasCommericalVehicle && (
              <div className="ferry-routes__form-type-toggle-container">
                <button
                  type="button"
                  className={`ferry-routes__form-type-toggle-btn ${
                    selected === 'leisure'
                      ? 'ferry-routes__form-type-toggle-btn--selected'
                      : ''
                  }`}
                  onClick={() => {
                    setSelected('leisure')
                    dispatch(setIsCommercial(false))
                  }}
                >
                  {labels.leisure}
                </button>
                <button
                  type="button"
                  className={`ferry-routes__form-type-toggle-btn ${
                    selected === 'commercial'
                      ? 'ferry-routes__form-type-toggle-btn--selected'
                      : ''
                  }`}
                  onClick={() => {
                    setSelected('commercial')
                    dispatch(setIsCommercial(true))
                  }}
                >
                  {labels.commercial}
                </button>
              </div>
            )} */}

            {!isEmpty(renderFormToggles) && (
              <div className="ferry-routes__form-type-toggles">
                {renderFormToggles}
              </div>
            )}
            {crossingsLoading ? (
              <BrandLoader />
            ) : (
              <>{routeFormElement && routeFormElement}</>
            )}
            {clientId !== 'mai' && availabilityErrors?.length ? (
              <div className="ferry-routes-errors-container">
                {availabilityErrors.map((error, i) => (
                  <p key={error + i}>{error}</p>
                ))}
              </div>
            ) : null}
          </div>
        </div>
      </div>
    </div>
  )
}

FerryRoutesFormsContainer.propTypes = {
  clientId: string.isRequired,
  availabilityErrors: arrayOf(node),
  customerAccount: oneOfType([shape(), bool]),
  travelAgentAccount: oneOfType([shape(), bool]),
  crossingsLoading: bool,
  labels: shape().isRequired,
  openModal: func.isRequired,
  renderFormToggles: array,
  routeFormElement: element,
  routeMap: string.isRequired,
  activeRouteGrouping: string
}

export default FerryRoutesFormsContainer
